export const normalizePhoneNumber = (phone: string) => {
  // removes all non-numeric characters and leading zeros
  return phone.replace(/^(?:0+(?=[1-9])|0+(?=0$))|[^0-9]+/g, '');
};
